module.exports = __webpack_public_path__ + "static/media/house-5.78f5ace1.jpg";